import localForage from "localforage"

localForage.config({
  name: 'Genomic Bleed App'
});

export default class OfflineStorage {
  static async getItem(name) {
    const response = await localForage.getItem(name);
    return response;
  }

  static async setItem(name, payload) {
    await localForage.setItem(name, payload);
  }

  static async removeItem(name) {
    await localForage.removeItem(name);
  }

  static async clear() {
    await localForage.clear();
  }
}